var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[_c('iframe',{ref:"iframe",staticClass:"iframe",attrs:{"src":_vm.frameUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }